import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';

/** @deprecated */
export const quoteStatusContactMeta = new Map<QuoteStatus, string>([
  [QUOTE_STATUSES.FormInitialized, $localize`In progress`],

  [QUOTE_STATUSES.FormSent, $localize`Renewal open`], // Applicable to ACCA Under only

  [QUOTE_STATUSES.FormIncomplete, $localize`In progress`],
  [QUOTE_STATUSES.FormComplete, $localize`Proposal submitted`],
  [QUOTE_STATUSES.OnHold, $localize`Proposal referred`],
  [
    QUOTE_STATUSES.HealthEvaluationRequired,
    $localize`Health evaluation required`,
  ],
  [
    QUOTE_STATUSES.HealthEvaluationActive,
    $localize`Health evaluation required`,
  ],
  [QUOTE_STATUSES.Quoted, $localize`Proposal submitted`],
  [QUOTE_STATUSES.BrokerApproved, $localize`Quote ready`],
  [QUOTE_STATUSES.AwaitingPayment, $localize`Awaiting payment`],
  [QUOTE_STATUSES.Complete, $localize`Completed`],
  [QUOTE_STATUSES.QuoteError, $localize`Error`],
]);

/** @deprecated */
export const quoteStatusBrokerMeta = new Map<QuoteStatus, string>([
  [QUOTE_STATUSES.FormInitialized, $localize`New proposal`],
  [QUOTE_STATUSES.FormSent, $localize`Proposal sent`],
  [QUOTE_STATUSES.FormIncomplete, $localize`Proposal in progress`],
  [QUOTE_STATUSES.FormComplete, $localize`Proposal complete`],
  [QUOTE_STATUSES.OnHold, $localize`Review required`],
  [
    QUOTE_STATUSES.HealthEvaluationRequired,
    $localize`Health evaluation required`,
  ],
  [
    QUOTE_STATUSES.HealthEvaluationActive,
    $localize`Health evaluation required`,
  ],
  [QUOTE_STATUSES.Quoted, $localize`Quote ready`],
  [QUOTE_STATUSES.QuoteAccepted, $localize`Quote accepted`],
  [QUOTE_STATUSES.BrokerApproved, $localize`Quote sent`],
  [QUOTE_STATUSES.AwaitingPayment, $localize`Awaiting payment`],
  [QUOTE_STATUSES.Complete, $localize`Completed`],
  [QUOTE_STATUSES.QuoteError, $localize`Error`],
]);
